
// Freigabe-Flags: Einträge mit `show: false` erscheinen erst, wenn die Freigabe vorliegt.
const PARTNERS = [
  { key: 'paraIceHockey', show: true },
  { key: 'dgsv', show: true, blog: '/blog/kooperation-der-deafgirls-mit-athlyzer/' },
  { key: 'bhv', show: true, blog: '/blog/bayerischer-hockeyverband-bhv-kooperiert-mit-athlyzer/' },
  { key: 'uniMainz', show: true, blog: '/blog/handball-analyse-mit-athlyzer-bei-der-uni-em-der-frauen/' },
  { key: 'bergtheim', show: true },
  { key: 'eisbaeren', show: true },
  { key: 'egyptHockey', show: true },
  { key: 'koblenz', show: false } // Vertragsstatus nach 31.03.2026 prüfen
]

const MEDIA = [
  { key: 'tuda', outlet: 'TU Darmstadt', year: '2021', url: 'https://www.tu-darmstadt.de/xchange/news_details_321728.en.jsp', show: false }, // Artikel nicht mehr online (Okt. 2026)
  { key: 'dzsm', outlet: 'Deutsche Zeitschrift für Sportmedizin', year: '', url: '', show: false } // Link + Jahr ergänzen, dann show: true
]

const KNOWLEDGE = [
  { key: 'guide', path: '/blog/videoanalyse-im-sport-dein-guide-fuer-leistungssteigerungen/', show: true },
  { key: 'feedback', path: '', show: false }, // nach Veröffentlichung Pfad eintragen
  { key: 'amateur', path: '', show: false } // nach Veröffentlichung Pfad eintragen
]

export default {
  name: 'UeberUnsPage',
  nuxtI18n: {
    paths: {
      de: '/ueber-uns',
      en: '/about-us'
    }
  },
  data () {
    return {
      facts: [
        { key: 'founded', value: '2017' },
        { key: 'servers', value: 'DE' },
        { key: 'sports', value: '6+' },
        { key: 'offline', value: 'DE · EN' }
      ],
      values: ['science', 'practice', 'simple', 'data'],
      milestones: [
        { key: 'm2017' },
        { key: 'm2018' },
        { key: 'm2019a' },
        { key: 'm2019b' },
        { key: 'm2021' },
        { key: 'm2023' },
        { key: 'm2025' },
        { key: 'm2026' }
      ]
    }
  },
  computed: {
    visiblePartners () { return PARTNERS.filter(p => p.show) },
    visibleMedia () { return MEDIA.filter(m => m.show && m.url) },
    visibleKnowledge () { return KNOWLEDGE.filter(k => k.show && k.path) }
  },
  head () {
    const title = this.$t('about.meta.title')
    const description = this.$t('about.meta.description')
    return {
      title: title + ' | ATHLYZER',
      meta: [
        { hid: 'description', name: 'description', content: description },
        { hid: 'og:title', property: 'og:title', content: title + ' | ATHLYZER' },
        { hid: 'og:description', property: 'og:description', content: description }
      ],
      script: [
        {
          hid: 'ld-organization',
          type: 'application/ld+json',
          json: {
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'ATHLYZER GmbH',
            url: 'https://www.athlyzer.com',
            logo: 'https://www.athlyzer.com/logo.png',
            foundingDate: '2017-07',
            founder: [
              { '@type': 'Person', name: 'Christoph Mickel', honorificPrefix: 'Dr.', url: 'https://www.athlyzer.com/team/christoph-mickel/' },
              { '@type': 'Person', name: 'Gerrit Kollegger', honorificPrefix: 'Dr.' },
              { '@type': 'Person', name: 'Janos Koschwitz' }
            ],
            address: {
              '@type': 'PostalAddress',
              streetAddress: 'Mittelstedter Weg 27 B',
              postalCode: '61348',
              addressLocality: 'Bad Homburg',
              addressCountry: 'DE'
            },
            sameAs: [
              'https://www.instagram.com/athlyzer/',
              'https://www.facebook.com/Athlyzer/'
            ]
          }
        }
      ]
    }
  }
}
